import * as React from "react";
import { useState } from "react";

interface ICustomHookProps {
    id: string,
    labelText: string,
    value: string,
    validationMessage: string,
    onClick: (e:any) => void;
    onChange(val: string): void,
    onErase(): void,
    onFocus(e:any): void,
}

export const customHooks = (labelText: string, id: string, connectKeyboard: { (arg0: (val: string) => void, arg1: string, arg2: string): void; (arg0: (val: string) => void, arg1: string, arg2: string): void; }, defaultValue: string = ""): [string, React.Dispatch<React.SetStateAction<string>>, ICustomHookProps] => {
    // tslint:disable-next-line: react-hooks-nesting
    const [value, setValue] = useState<string>(defaultValue);
    const onChange = (val: string) => setValue(val);
    const onErase = () => { setValue(""); connectKeyboard(onChange, "", id) }
    return [
        value,
        setValue,
        {
            id,
            labelText,
            value,
            onChange,
            onClick: (e) => e.stopPropagation(),
            onFocus: (e) => {e.stopPropagation(); connectKeyboard(onChange, value, id);},
            validationMessage: "Required",
            onErase
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/ClinicLoginPage/Hooks.tsx